import React, { useState, useEffect } from 'react';

type FilterType = {
  [key: string]: { group: string; label: string; query: string };
};

type FacetType = {
  [key: string]: { label: string; query: string };
};

type SortType = {
  [key: string]: { label: string; field: string };
};

export type HierarchicalFacetValue = {
  CN: string;
  term: string;
};

type HierarchicalFacetType = {
  [key: string]: {
    label: string;
    CN: string;
  };
};

interface SearchValue {
  source: string;
  text: string;
}

export type SearchType = {
  identifier: string;
  field: string;
  searchValues: SearchValue[];
};

interface CustomSearchCriterion {
  field: string;
  fieldLabel: string;
  searchValues: string[];
  description: string;
}

export class Search implements SearchType {
  public identifier: string;
  public field: string;
  public searchValues: SearchValue[];

  constructor(identifier: string, field: string, searchValues: SearchValue[] = []) {
    this.identifier = identifier;
    this.field = field;
    this.searchValues = searchValues;
  }
}

class CC {
  public Searches: Search[] = [];
  matchAllCriteria: boolean = true;
  public filters: string[] = []; // This will store the filter keys the user selects
  public facets: { [field: string]: string[] } = {}; // This will store the facet fields the user selects
  public hierarchicalFacets: { [key: string]: HierarchicalFacetValue[] } = {};
  public customSearchCriteria: CustomSearchCriterion[] = [];

  constructor() {}
}

class CcConfig {

  simpleSearchFields: {
    [key: string]: {
      field: string;
      browse: boolean;
    };
  } = {
    "All search fields": {
      field: "/Record/Title/Title,/Record/Description,/Record/ObjectNumber,/Record/ObjectNumberUnparsed,/Record/ObjectNumber2,/Record/ObjAltnum/Altnum,/Record/ConXall/AlphaSort,/Record/mqb_thesterm/TermPath,/Record/Collection/Name,/Record/Evenement/Evenement,/Record/Evenement/Description,/Record/Department,/Record/Medium",
      browse: false,
    },
    "Title": {
      field: "/Record/Title/Title",
      browse: true,
    },
    "Object Number": {
      field: "/Record/ObjectNumberUnparsed",
      browse: true,
    },
    //"Object Number Wildcard": {
    //  field: "/Record/ObjectNumberUnparsed",
    //  browse: true,
    //},
    "Place": {
      field: "/Record/Toponyme/Term",
      browse: true,
    },
    "Ethnonym": {
      field: "/Record/Ethnonyme/Term",
      browse: true,
    },
    "Culture(s)": {
      field: "/Record/Culture/Culture",
      browse: true,
    },
    "Persons/Institutions": {
      field: "/Record/ConXall/AlphaSort",
      browse: true,
    },
    "Materials & Techniques": {
      field: "/Record/Medium",
      browse: true,
    },
    "Department": {
      field: "/Record/Department",
      browse: true,
    }
  };

  //advancedSearchFields wordt voor MQB niet gebruikt
  //Bij MQB wordt de advanced search gedaan met de simple search
  advancedSearchFields: {
    [key: string]: {
      field: string;
      browse: boolean;
    };
  } = {
    "Title": {
      field: "/Record/Title/Title",
      browse: true,
    },
    "Object Number": {
      field: "/Record/ObjectNumber",
      browse: true,
    },  
    //"Object Number Wildcard": {
    //  field: "/Record/ObjectNumberUnparsed",
    //  browse: true,
    //},  
    "Place": {
      field: "/Record/Toponyme/Term",
      browse: true,
    },
    "Ethnonym": {
      field: "/Record/Ethnonyme/Term",
      browse: true,
    },
    "Culture(s)": {
      field: "/Record/Culture/Culture",
      browse: true,
    },
    "Persons/Institutions": {
      field: "/Record/Creator/AlphaSort",
      browse: true,
    },
    "Materials & Techniques": {
      field: "/Record/Medium",
      browse: true,
    },
    "Department": {
      field: "/Record/Department",
      browse: true
    }
  };

  mobileSearchFields: {
    [key: string]: {
      field: string;
      browse: boolean;
    };
  } = {
    "All search fields": {
      field: "/Record/Title/Title,/Record/Description,/Record/ObjectNumber,/Record/ObjectNumberUnparsed,/Record/ObjectNumber2,/Record/ConXall/AlphaSort,/Record/mqb_thesterm/TermPath,/Record/Collection/Name,/Record/Evenement/Evenement",
      browse: false,
    },
    "Title": {
      field: "/Record/Title/Title",
      browse: true,
    },
    "Object Number": {
      field: "/Record/ObjectNumber",
      browse: true,
    },
    //"Object Number Wildcard": {
    //  field: "/Record/ObjectNumberUnparsed",
    //  browse: true,
    //},
    "Place": {
      field: "/Record/Toponyme/Term",
      browse: true,
    },
    "Ethnonym": {
      field: "/Record/Ethnonyme/Term",
      browse: true,
    },
    "Culture(s)": {
      field: "/Record/Culture/Culture",
      browse: true,
    },
    "Persons/Institutions": {
      field: "/Record/ConXall/AlphaSort",
      browse: true,
    },
    "Materials & Techniques": {
      field: "/Record/Medium",
      browse: true,
    },
    "Department": {
      field: "/Record/Department",
      browse: true,
    }
  };

  filters: FilterType = {
    filter_objects: { group: "A", label: "Objects", query: "/Record/source=objects" },
    filter_icono: { group: "A", label: "Iconography", query: "/Record/source=icono" },
    filter_freeOfRights: { group: "B", label: "Free to use Images", query: "CN=[ICO.AAN.AAB.AAC]" },
    filter_exhibited: { group: "C", label: "Exhibited objects", query: "Expose=Oui" },  
  };

  facets: FacetType = {
    categorie: { label: "facet_category", query: "/Record/classification" },
    // personnes: { label: "facet_persons", query: "/Record/ConX/AlphaSortConX" },
    personnes: { label: "facet_persons", query: "/Record/ConXAll/AlphaSort" },
    continents: { label: "facet_continents", query: "/Record/Continent/Term" },
    countries: { label: "facet_countries", query: "/Record/Country/Term" },
  };

  hierarchicalFacets: HierarchicalFacetType = {
    culture: { label: "facet_culture", CN: "MQY"},
    toponyme: { label: "facet_geography", CN: "MQX"},
  }

  sort: SortType = {
    relevance: {label: "Relevance", field: "ccRelevance"},
    title: {label: "Title", field: "/Record/Title/Title"},
    objectNumber: {label: "Object number", field: "/Record/ObjectNumber,/Record/ObjectNumber2"},
    date: {label: "Date(s)", field: "/Record/DateBegin"},
    department: {label: "Department", field: "/Record/Department"}
  }

}

let ccConfig = new CcConfig();

export { CC, ccConfig };
